/// <reference types="vite/client" />
import { BlockElement } from '@blocksuite/lit';
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import { isPageMode, matchFlavours } from '../_common/utils/index.js';
import { AffineDragHandleWidget } from '../_common/widgets/index.js';
import { KeymapController } from './keymap-controller.js';
import { type NoteBlockModel, NoteBlockSchema } from './note-model.js';

@customElement('affine-note')
export class NoteBlockComponent extends BlockElement<NoteBlockModel> {
  static override styles = css`
    .affine-note-block-container {
      display: flow-root;
      position: relative;
    }
    .affine-note-block-container.selected {
      background-color: var(--affine-hover-color);
    }
  `;

  keymapController = new KeymapController(this);

  private _registerDragHandleOption = () => {
    this._disposables.add(
      AffineDragHandleWidget.registerOption({
        flavour: NoteBlockSchema.model.flavour,
        onDragEnd: (_, { draggingElements, dropBlockId, dropType }) => {
          if (
            isPageMode(this.page) ||
            draggingElements.length !== 1 ||
            !matchFlavours(draggingElements[0].model, [
              NoteBlockSchema.model.flavour,
            ])
          ) {
            return false;
          }

          const noteBlock = draggingElements[0].model as NoteBlockModel;
          const targetBlock = this.page.getBlockById(dropBlockId);
          const parentBlock = this.page.getParent(dropBlockId);
          if (targetBlock && parentBlock && dropType !== 'in') {
            this.page.moveBlocks(
              noteBlock.children,
              parentBlock,
              targetBlock,
              dropType === 'before'
            );
            this.page.deleteBlock(noteBlock);
          }

          return true;
        },
      })
    );
  };

  override connectedCallback() {
    super.connectedCallback();
    this.keymapController.bind();
    this._registerDragHandleOption();
  }

  override render() {
    return html`
      <div class="affine-note-block-container">
        <div class="affine-block-children-container">
          ${this.renderModelChildren(this.model)}
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'affine-note': NoteBlockComponent;
  }
}
